module.exports = __webpack_public_path__ + "img/qixiangweixingzhan.8849d09b.png";